import {Component} from '@angular/core';
import {HeaderService} from '../../header.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
    })
export class ContactComponent {

    constructor(private headerService: HeaderService) {
        this.headerService.setHeaderImage('assets/img/contact/background.jpg');
        this.headerService.setHeaderTitle('Kontakt');
        this.headerService.setHeaderContext('Die Metzgerei Rettensteiner-Scharfetter in St. Johann im Pongau ist' +
            ' für alle da, die sich bewusst und mit Freude ernähren. Fleisch ist hier kein billiger Sattmacher,' +
            ' sondern ein wertvoller Bestandteil einer ausgewogenen Ernährung – wer auf Herkunft und Qualität' +
            ' denselben Wert legt, ist bei uns genau richtig.');
    }
}
